import React from 'react';
import type { IconType } from 'react-icons';

type IconProps = { icon: IconType; className?: string };
export default function Icon({ icon: IconComp, className }: IconProps) {
    const Comp = IconComp as unknown as React.ComponentType<{ className?: string }>;
    return <Comp className={className} />;
}
